import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useEventContent } from "@/context/EventContentContext";

export default function FAQ() {
  const { faqs } = useEventContent();

  return (
    <div data-testid="faq-page" className="section-pad">
      <div className="container-cg max-w-4xl">
        <div className="overline text-[var(--brand-primary)]">Preguntas frecuentes</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          Lo que debes saber.
        </h1>

        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-b border-[var(--brand-border)]"
            >
              <AccordionTrigger className="font-serif-cg text-lg md:text-xl py-6 hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--brand-ink)]/80 leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
